angular.module('filters').filter('membershipPlanKioskPricingFilter', ["$filter", function($filter) {
  return function(plan, currency) {
    var repeatPayment, upfrontPayment;
    upfrontPayment = $filter('currency')(plan.cost_upfront_cents / 100, currency);
    repeatPayment = $filter('currency')(plan.cost_repeat_cents / 100, currency);
    if (plan.cost_repeat_cents > 0 && plan.charge_interval_unit) {
      if (plan.cost_upfront_cents > 0) {
        return `${upfrontPayment} up-front + ${repeatPayment} recurring`;
      } else {
        return `${repeatPayment} recurring`;
      }
    } else {
      if (plan.cost_upfront_cents > 0) {
        return `${upfrontPayment} up-front`;
      } else {
        return "FREE";
      }
    }
  };
}]);
